var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifiicnRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_115_286",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#e33745"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_115_286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.61572 9.9135C2.61572 8.43917 2.92881 7.07825 3.55497 5.83075C4.18131 4.58342 5.02656 3.53025 6.09072 2.67125L7.01547 3.8385C6.12447 4.559 5.41839 5.44233 4.89722 6.4885C4.37622 7.53467 4.11572 8.67633 4.11572 9.9135H2.61572ZM19.8847 9.9135C19.8847 8.67633 19.6242 7.53308 19.1032 6.48375C18.5821 5.43442 17.876 4.54942 16.985 3.82875L17.9097 2.67125C18.9739 3.53025 19.8191 4.58342 20.4455 5.83075C21.0716 7.07825 21.3847 8.43917 21.3847 9.9135H19.8847ZM4.50022 18.8845V17.3848H6.30797V9.923C6.30797 8.57817 6.72306 7.38908 7.55322 6.35575C8.38322 5.32242 9.44889 4.6615 10.7502 4.373V3.75C10.7502 3.40383 10.8721 3.109 11.1157 2.8655C11.3592 2.62183 11.6541 2.5 12.0002 2.5C12.3464 2.5 12.6412 2.62183 12.8847 2.8655C13.1284 3.109 13.2502 3.40383 13.2502 3.75V4.373C14.5516 4.6615 15.6172 5.32242 16.4472 6.35575C17.2774 7.38908 17.6925 8.57817 17.6925 9.923V17.3848H19.5002V18.8845H4.50022ZM12.0002 21.6923C11.5016 21.6923 11.0756 21.5157 10.7225 21.1625C10.3691 20.8093 10.1925 20.3833 10.1925 19.8845H13.808C13.808 20.3833 13.6313 20.8093 13.278 21.1625C12.9248 21.5157 12.4989 21.6923 12.0002 21.6923ZM7.80797 17.3848H16.1925V9.923C16.1925 8.76533 15.7832 7.77725 14.9647 6.95875C14.1461 6.14008 13.1579 5.73075 12.0002 5.73075C10.8426 5.73075 9.85439 6.14008 9.03572 6.95875C8.21722 7.77725 7.80797 8.76533 7.80797 9.923V17.3848Z",
    fill: "#e33745"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifiicnRed);
export default __webpack_public_path__ + "static/media/NotifiicnRed.d14ae840f31addb3ee2c86dcf4103522.svg";
export { ForwardRef as ReactComponent };